import { useState, useEffect } from "react";
import { formatTime } from "./data";

interface CountdownTimerProps {
  storedCurrentSessionStartTime: number; // Timestamp in ms
  onEnd: () => Promise<any>;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({
  storedCurrentSessionStartTime,
  onEnd,
}) => {
  const TEN_MINUTES_MS = 10 * 60 * 1000;

  const [timeLeft, setTimeLeft] = useState<number>(0);

  const getTimePercentage = (): number => {
    return (timeLeft / (TEN_MINUTES_MS / 1000)) * 100;
  };

  const getColorClasses = (): string => {
    const percentage = getTimePercentage();

    if (percentage > 50) {
      return "text-green-600 bg-green-50 border-green-200";
    } else if (percentage > 25) {
      return "text-yellow-600 bg-yellow-50 border-yellow-200";
    } else {
      return "text-red-600 bg-red-50 border-red-200";
    }
  };

  useEffect(() => {
    const sessionEndTime = storedCurrentSessionStartTime + TEN_MINUTES_MS;
    let interval: NodeJS.Timeout | undefined;
    let requestCalled = false;

    const updateTimer = () => {
      const remainingMs = sessionEndTime - Date.now();
      const remainingSeconds = Math.max(0, Math.floor(remainingMs / 1000));
      setTimeLeft(remainingSeconds);

      if (remainingMs <= 0 && !requestCalled) {
        requestCalled = true;
        clearInterval(interval);
        onEnd().catch((err) => {
          console.error("API request failed:", err);
        });
      }
    };

    updateTimer(); // Call immediately
    interval = setInterval(updateTimer, 1000);

    return () => clearInterval(interval);
  }, [storedCurrentSessionStartTime, onEnd, TEN_MINUTES_MS]);

  return (
    <div className={`transition-all duration-300 ${getColorClasses()} `}>
      <span className="hidden lg:inline">Time Left:</span>{" "}
      {formatTime(timeLeft)}
    </div>
  );
};

export default CountdownTimer;
